module.exports = __webpack_public_path__ + "static/media/line-graph-a-second-y-LR05.9ba0816d.png";